import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由组件
const Dashboard = () => import('../views/Dashboard.vue')
const CarInfo = () => import('../views/CarInfo.vue')
const CompanyInfo = () => import('../views/CompanyInfo.vue')
const WorkOrderInfo = () => import('../views/WorkOrderInfo.vue')
const DailyFlow = () => import('../views/DailyFlow.vue')
const CustomerServiceMenu = () => import('../views/CustomerServiceMenu.vue')
const ManagementMenu = () => import('../views/ManagementMenu.vue')
const SystemTypeManagement = () => import('../views/management/SystemTypeManagement.vue')
const OrderTypeManagement = () => import('../views/management/OrderTypeManagement.vue')
const DeviceModelManagement = () => import('../views/management/DeviceModelManagement.vue')
const VehicleTypeManagement = () => import('../views/management/VehicleTypeManagement.vue')
const ProcessTypeManagement = () => import('../views/management/ProcessTypeManagement.vue')
const PaymentTypeManagement = () => import('../views/management/PaymentTypeManagement.vue')
const InstallerManagement = () => import('../views/management/InstallerManagement.vue')
const RepairAreaManagement = () => import('../views/management/RepairAreaManagement.vue')
const UserManagement = () => import('../views/management/UserManagement.vue')
const DataStatistics = () => import('../views/DataStatistics.vue')
const StatementInfo = () => import('../views/StatementInfo.vue')
const FlowStat = () => import('../views/statistics/FlowStat.vue')
const CommissionDetail = () => import('../views/statistics/CommissionDetail.vue')
const SplitVehicleData = () => import('../views/SplitVehicleData.vue')
const Login = () => import('../views/Login.vue')
const LogManagement = () => import('../views/management/LogManagement.vue')
// 客服管理相关组件
const ShutdownRegistration = () => import('../views/customer-service/ShutdownRegistration.vue')
const StartupRegistration = () => import('../views/customer-service/StartupRegistration.vue')
const VehicleShutdownOperation = () => import('../views/customer-service/VehicleShutdownOperation.vue')
const TransferRegistration = () => import('../views/customer-service/TransferRegistration.vue')
const InstallationRegistration = () => import('../views/customer-service/InstallationRegistration.vue')
const CardReplacementRegistration = () => import('../views/customer-service/CardReplacementRegistration.vue')
const DeviceReplacementRegistration = () => import('../views/customer-service/DeviceReplacementRegistration.vue')
const SalarySlipQuery = () => import('../views/customer-service/SalarySlipQuery.vue')
const CancelOrderRecord = () => import('../views/customer-service/CancelOrderRecord.vue')
// const VehicleCardManagement = () => import('../views/customer-service/VehicleCardManagement.vue')
// 库存管理相关组件
const InventoryManagement = () => import('../views/inventory/InventoryManagement.vue')

const routes = [
  { path: '/login', component: Login },
  {
    path: '/',
    redirect: () => {
      const role = localStorage.getItem('role') || ''

      // 客服用户始终重定向到工单页面
      if (role === '客服' || role === 'customer_service') {
        return '/customer-service/workorder'
      }

      // 非客服用户的重定向逻辑
      try {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '{}')

        // 优先重定向到dashboard
        if (permissions.dashboard?.can_view) {
          return '/dashboard'
        }

        // 如果没有dashboard权限，找第一个有权限的页面
        const allowedRoutes = [
          { key: 'car', route: '/car' },
          { key: 'company', route: '/company' },
          { key: 'dailyflow', route: '/dailyflow' }
        ]

        for (const item of allowedRoutes) {
          if (permissions[item.key]?.can_view) {
            return item.route
          }
        }

        // 如果都没有权限，默认到登录页
        return '/login'
      } catch (e) {
        // 解析权限失败时重定向到登录页
        return '/login'
      }
    }
  },
  // 处理旧的 /workorder 路由重定向
  { path: '/workorder', redirect: '/customer-service/workorder' },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/car', component: CarInfo, meta: { requiresAuth: true } },
  { path: '/company', component: CompanyInfo, meta: { requiresAuth: true } },
  { path: '/dailyflow', component: DailyFlow, meta: { requiresAuth: true } },
  {
    path: '/customer-service',
    component: CustomerServiceMenu,
    meta: { requiresAuth: true },
    children: [
      { path: 'workorder', component: WorkOrderInfo },
      { path: 'cancel-order-record', component: CancelOrderRecord },
      { path: 'vehicle-operation', component: VehicleShutdownOperation },
      { path: 'shutdown-registration', component: ShutdownRegistration },
      { path: 'startup-registration', component: StartupRegistration },
      { path: 'transfer-registration', component: TransferRegistration },
      { path: 'installation-registration', component: InstallationRegistration },
      { path: 'card-replacement-registration', component: CardReplacementRegistration },
      { path: 'device-replacement-registration', component: DeviceReplacementRegistration },
      { path: 'salary-slip-query', component: SalarySlipQuery },
      // { path: 'vehicle-card-management', component: VehicleCardManagement }
    ]
  },
  {
    path: '/management',
    component: ManagementMenu,
    meta: { requiresAuth: true },
    children: [
      { path: 'system-type', component: SystemTypeManagement },
      { path: 'order-type', component: OrderTypeManagement },
      { path: 'device-model', component: DeviceModelManagement },
      { path: 'vehicle-type', component: VehicleTypeManagement },
      { path: 'process-type', component: ProcessTypeManagement },
      { path: 'payment-type', component: PaymentTypeManagement },
      { path: 'installer', component: InstallerManagement },
      { path: 'repair-area', component: RepairAreaManagement },
      { path: 'user-management', component: UserManagement },
      { path: 'log-management', component: LogManagement }
    ]
  },
  {
    path: '/statistics',
    component: DataStatistics,
    meta: { requiresAuth: true },
    children: [
      { path: 'statement', component: StatementInfo },
      { path: 'flowstat', component: FlowStat },
      { path: 'commission-detail', component: CommissionDetail },
      { path: 'split-vehicle-data', component: SplitVehicleData }
    ]
  },
  // 库存管理路由
  { path: '/inventory', component: InventoryManagement, meta: { requiresAuth: true } }
]

const router = new VueRouter({
  routes
})

// 捕获路由重定向错误，避免在控制台显示错误信息
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
      throw err
    }
  })
}

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
      throw err
    }
  })
}

// 添加重定向标志，防止无限重定向
let isRedirecting = false

// 菜单配置（与 App.vue 保持一致）
const menuList = [
  { key: 'dashboard', label: '数据统计首页', icon: 'el-icon-data-analysis', route: '/dashboard' },
  { key: 'car', label: '车辆信息', icon: 'el-icon-truck', route: '/car' },
  { key: 'company', label: '公司信息', icon: 'el-icon-office-building', route: '/company' },
  { key: 'dailyflow', label: '每日流水', icon: 'el-icon-date', route: '/dailyflow' },
  {
    key: 'customer-service', label: '客服管理', icon: 'el-icon-service', children: [
      { key: 'workorder', label: '工单信息', route: '/customer-service/workorder' },
      { key: 'cancel-order-record', label: '撤单记录', route: '/customer-service/cancel-order-record' },
      { key: 'vehicle-operation', label: '车辆停机/开机操作', route: '/customer-service/vehicle-operation' },
      { key: 'transfer-registration', label: '过户登记', route: '/customer-service/transfer-registration' },
      { key: 'installation-registration', label: '拆装登记', route: '/customer-service/installation-registration' },
      { key: 'card-replacement-registration', label: '车载号码更换登记', route: '/customer-service/card-replacement-registration' },
      { key: 'device-replacement-registration', label: '设备号更换登记', route: '/customer-service/device-replacement-registration' },
      { key: 'salary-slip-query', label: '工资条查询', route: '/customer-service/salary-slip-query' },
      // { key: 'vehicle-card-management', label: '车载卡管理', route: '/customer-service/vehicle-card-management' }
    ]
  },
  {
    key: 'management', label: '管理菜单', icon: 'el-icon-s-tools', children: [
      { key: 'system-type', label: '系统类型管理', route: '/management/system-type' },
      { key: 'order-type', label: '下单类型管理', route: '/management/order-type' },
      { key: 'device-model', label: '设备型号管理', route: '/management/device-model' },
      { key: 'vehicle-type', label: '车辆类型管理', route: '/management/vehicle-type' },
      { key: 'process-type', label: '处理类型管理', route: '/management/process-type' },
      { key: 'payment-type', label: '收费类型管理', route: '/management/payment-type' },
      { key: 'installer', label: '安装师傅管理', route: '/management/installer' },
      { key: 'repair-area', label: '维修区域管理', route: '/management/repair-area' },
      { key: 'user-management', label: '用户管理', route: '/management/user-management' },
      { key: 'log-management', label: '日志管理', route: '/management/log-management' }
    ]
  },
  {
    key: 'statistics', label: '数据统计', icon: 'el-icon-pie-chart', children: [
      { key: 'statement', label: '对账单', route: '/statistics/statement' },
      { key: 'flowstat', label: '流水账单统计', route: '/statistics/flowstat' },
      { key: 'commission-detail', label: '提成明细', route: '/statistics/commission-detail' },
      { key: 'split-vehicle-data', label: '拆分车辆数据', route: '/statistics/split-vehicle-data' }
    ]
  },
  // 库存管理菜单
  { key: 'inventory-management', label: '库存管理', icon: 'el-icon-box', route: '/inventory' }
]

// 获取所有有权限的路由
function getAllRoutes(menus) {
  let routes = []
  for (const item of menus) {
    if (item.children && item.children.length > 0) {
      routes = routes.concat(getAllRoutes(item.children))
    } else if (item.route) {
      routes.push(item.route)
    }
  }
  return routes
}

// 路由守卫：只在这里做权限跳转，避免多处重复跳转
router.beforeEach((to, from, next) => {
  const access = localStorage.getItem('access')

  // 处理登录页访问
  if (to.path === '/login') {
    if (!access) {
      // 未登录时可以访问登录页
      next()
      return
    }

    // 已登录时访问登录页，根据角色重定向
    const role = localStorage.getItem('role') || ''
    if (role === '客服' || role === 'customer_service') {
      next('/customer-service/workorder')
      return
    }

    if (role === '库存管理员' || role === 'inventory_manager') {
      next('/inventory')
      return
    }

    // 非客服和非库存管理员用户重定向逻辑
    let permissions = {}
    try {
      permissions = JSON.parse(localStorage.getItem('permissions') || '{}')
    } catch (e) {
      // 解析失败时使用空对象
    }

    if (permissions.dashboard?.can_view) {
      next('/dashboard')
      return
    }

    // 找第一个有权限的页面
    const allowedKeys = Object.keys(permissions)
    if (allowedKeys.length > 0) {
      const firstAllowedRoute = getAllRoutes(menuList).find(route => {
        const routeParts = route.split('/').filter(Boolean)
        const routeKey = routeParts[routeParts.length - 1]
        return allowedKeys.includes(routeKey) && permissions[routeKey]?.can_view
      })
      if (firstAllowedRoute) {
        next(firstAllowedRoute)
        return
      }
    }

    // 如果没有任何权限，保持在登录页
    next()
    return
  }

  // 如果未登录，跳转到登录页
  if (!access) {
    next('/login')
    return
  }

  // 已登录，校验权限
  let permissions = {}
  let role = ''
  try {
    permissions = JSON.parse(localStorage.getItem('permissions') || '{}')
    role = localStorage.getItem('role') || ''
  } catch (e) {
    // 解析失败时使用空对象
  }

  // 特殊处理客服角色 - 修复版本
  if (role === '客服' || role === 'customer_service') {
    // 客服用户可以访问的路由（不包含车辆信息）
    const customerServiceAllowedRoutes = [
      '/company',  // 公司信息
      '/customer-service/workorder',
      '/customer-service/cancel-order-record',
      '/customer-service/vehicle-operation',
      '/customer-service/shutdown-registration',
      '/customer-service/startup-registration',
      '/customer-service/transfer-registration',
      '/customer-service/installation-registration',
      '/customer-service/card-replacement-registration',
      '/customer-service/device-replacement-registration',
      '/customer-service/salary-slip-query',
      // '/customer-service/vehicle-card-management'
    ]

    // 检查客服用户是否有权限访问目标路由
    if (!customerServiceAllowedRoutes.includes(to.path)) {
      // 静默重定向，不抛出错误
      next('/customer-service/workorder')
      return
    }

    // 客服用户访问允许的路由，直接通过
    next()
    return
  }

  // 特殊处理库存管理员角色
  if (role === '库存管理员' || role === 'inventory_manager') {
    // 库存管理员用户可以访问的路由
    const inventoryManagerAllowedRoutes = [
      '/inventory'  // 库存管理页面
    ]

    // 检查库存管理员用户是否有权限访问目标路由
    if (!inventoryManagerAllowedRoutes.includes(to.path)) {
      // 静默重定向，不抛出错误
      next('/inventory')
      return
    }

    // 库存管理员用户访问允许的路由，直接通过
    next()
    return
  }

  // 非客服用户的权限处理
  const allowedKeys = Object.keys(permissions)

  // 获取实际的路由权限
  let allowedRoutes = getAllRoutes(menuList).filter(route => {
    // 在菜单列表中查找对应的菜单项
    const findMenuByRoute = (menus, targetRoute) => {
      for (const menu of menus) {
        if (menu.route === targetRoute) {
          return menu
        }
        if (menu.children) {
          const found = findMenuByRoute(menu.children, targetRoute)
          if (found) return found
        }
      }
      return null
    }

    const menuItem = findMenuByRoute(menuList, route)
    if (menuItem && menuItem.key) {
      const hasPermission = allowedKeys.includes(menuItem.key) && permissions[menuItem.key]?.can_view
      // 权限检查完成
      return hasPermission
    }

    // 兼容旧的逻辑
    const routeParts = route.split('/').filter(Boolean)
    const routeKey = routeParts[routeParts.length - 1]
    const hasPermission = allowedKeys.includes(routeKey) && permissions[routeKey]?.can_view
    return hasPermission
  })

  // 如果目标路由不在有权限的路由里，跳转到第一个有权限的页面
  if (!allowedRoutes.includes(to.path)) {
    // 防止无限重定向
    if (isRedirecting) {
      next(false)
      return
    }

    if (allowedRoutes.length > 0) {
      isRedirecting = true
      const targetRoute = permissions.dashboard?.can_view ? '/dashboard' : allowedRoutes[0]
      next(targetRoute)
      // 重置重定向标志
      setTimeout(() => {
        isRedirecting = false
      }, 100)
    } else {
      // 没有任何权限，跳转到登录页
      isRedirecting = true
      next('/login')
      // 重置重定向标志
      setTimeout(() => {
        isRedirecting = false
      }, 100)
    }
    return
  }
  next()
})

export default router 